import { render, staticRenderFns } from "./FarmGis.vue?vue&type=template&id=00bd4860"
import script from "./FarmGis.vue?vue&type=script&lang=js"
export * from "./FarmGis.vue?vue&type=script&lang=js"
import style0 from "./FarmGis.vue?vue&type=style&index=0&id=00bd4860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports